export const LIST_FILTER_KEYS = {
  USERS: "users",
  CITIES: "cities",
  SCHOOLS: "schools",
};

export const showDeletedCheckboxSx = {
  color: "#acb3bd",
  "&.Mui-checked": {
    color: "primary.main",
    backgroundColor: "primary.main",
    backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e")`,
    backgroundSize: "contain",
    borderColor: "primary.main",
    "&:hover": {
      backgroundColor: "primary.main",
    },
  },
};

export const showDeletedLabelSx = {
  "& .MuiFormControlLabel-label": {
    fontSize: "14px",
    color: "black.main",
  },
};
